import { Component, OnInit,Input ,Output,EventEmitter} from '@angular/core';
import { Modules } from "../../utils/enumeration";
import { generaleMethodes } from '../../shared/generaleMethodes.component';
import { SearchCriteriaPricingBooking } from "../../utils/SearchCriteriaPricingBooking";

@Component({
  selector: 'app-advanced-search',
  templateUrl: './advanced-search.component.html',
  styleUrls: ['./advanced-search.component.css']
})
export class AdvancedSearchComponent implements OnInit {

  @Input() module: number;
  @Output() onSearch = new EventEmitter<SearchCriteriaPricingBooking>();
  
  constructor(public generaleMethode : generaleMethodes) { }

  ngOnInit() {

  }

  panelCollapse(panel, event) {
    this.generaleMethode.panelCollapse(panel, event);
  }

  search(search: SearchCriteriaPricingBooking) {

    this.onSearch.emit(search);

  }

  

}



// WEBPACK FOOTER //
// ./src/app/shared/advanced-search/advanced-search.component.ts